<div fxLayout="column" fxLayoutGap="40px">
  <div>
    <h4>Portal System Colors</h4>
    <div fxLayout="row wrap" fxLayoutGap="20px">
      @for (item of (themeData.system | keyvalue); track item.key) {
        <div [ngStyle]="{ background: item.value, height: '150px', width: '400px' }" class="swatch-container">
          <div class="swatch-text" fxLayout="row" fxLayoutAlign="space-between center">
            <span>{{ item.key }}</span>
            <span>{{ item.value }}</span>
          </div>
        </div>
      }
    </div>
  </div>

  <div>
    <h4>Portal Extended Colors</h4>
    <div fxLayout="row wrap" fxLayoutGap="10px">
      @for (item of themeData.extended | keyvalue; track item.key) {
        <div [ngStyle]="{ background: item.value, height: '150px', width: '400px' }" class="swatch-container">
          <div class="swatch-text" fxLayout="row" fxLayoutAlign="space-between center">
            <span>{{ item.key }}</span>
            <span>{{ item.value }}</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
